// extracted by mini-css-extract-plugin
module.exports = {"overflow_hidden":"overflow_overflow_hidden__WbHQF","halfsquare":"overflow_halfsquare__3Fj_S","image_container":"overflow_image_container__3-ipa"};